export function isStringNullOrEmpty(str: string | undefined | null, trimWhiteSpaces = false): boolean {
  if (typeof str == 'undefined' || !str) return true;
  if (trimWhiteSpaces && !str.trim()) return true;
  return false;
}

const EMAIL_REGEXP =
  /^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

export function isEmail(str: string): boolean {
  if (isStringNullOrEmpty(str, true)) return false;

  let regex = new RegExp(EMAIL_REGEXP);
  return regex.test(str);
}

export function camelToSpaceCase(inputString: string) {
  return inputString
    .split('')
    .map(character => {
      if (character == character.toUpperCase()) {
        return ' ' + character.toLowerCase();
      } else {
        return character;
      }
    })
    .join('');
}
